import React, {Component} from "react";
import Select from "../../../local_node_modules/react-select";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {PdfNameEnum} from "../../../helper/enums";

class DocumentNaming extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: null
        };
        this.onSave = this.onSave.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        const {customer} = this.props;
        let selectedType = customer.pdfName;

        let defaultVal = "DOCUMENT_ID_DOCUMENT_UUID";

        if (
            selectedType !== "ALICI_VEYA_GONDERICI_DOCUMENT_ID" &&
            selectedType !== "ALICI_VEYA_GONDERICI_DOCUMENT_UUID" &&
            selectedType !== "DOCUMENT_ID" &&
            selectedType !== "DOCUMENT_ID_DOCUMENT_UUID" &&
            selectedType !== "DOCUMENT_UUID" &&
            selectedType !== "DOCUMENT_UUID_DOCUMENT_ID"
        ) {
            selectedType = defaultVal;
        }
        this.setState({type: selectedType});
    }


    onSave() {
        let {type} = this.state;
        if (!type) {
            type = "DOCUMENT_ID_DOCUMENT_UUID";
        }
        let params = {
            url: "/customer/changeOnNameFormatPdf",
            method: "post",
            data: type
        };
        request(params)
            .then(() => {
                Alert.success("Kayıt başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            })
            .catch(() => {
                Alert.error("Kayıt başarısız.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            });
    }

    handleSelectChange(selectedOption) {
        this.setState({type: selectedOption.value});
    }

    renderOptions() {
        return Object.entries(PdfNameEnum).map(([key, value]) => ({
            value: key,
            label: value
        }));
    }

    render() {
        const namingTypes = [
            {value: "EFATURA", label: "E-Fatura"}
        ];
        return (
            <div className={'FormRenk'}>
                <div className={"row"}>
                    <div className={"col-md-3"}>
                        <label>Toplu Pdf İndir İsimlendirme: </label>
                    </div>

                    <div className={"col-md-4"} style={{paddingRight: '100px'}}>
                        <Select
                            clearable={false}
                            className="select-control"
                            value={
                                this.renderOptions().find(option => option.value === (this.state.type || "DOCUMENT_ID_DOCUMENT_UUID"))
                            }
                            placeholder="Seçiniz..."
                            onChange={this.handleSelectChange}
                            options={this.renderOptions()}
                        />
                    </div>
                    <div className={"col-md-2"}></div>
                    <div className={"col-md-2"}>
                        <button type="button" data-toggle="tooltip" data-placement="top"
                                style={{
                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                    float: 'right'
                                }}
                                rel="tooltip" className="TekBtn kaydet btn-icon"
                                onClick={this.onSave}>Kaydet
                        </button>
                    </div>

                </div>

            </div>
        )
    }

}

export default DocumentNaming;
